import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';
import { format, parse } from 'date-fns';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect, useState } from 'react';
import { CustomTabPanel, CustomTabsV2 } from '../../../components/StyledComponents';
import { Tab, Tooltip } from '@mui/material';
import VisitorsTab from './VisitorsTab';
import RequestsTab from './RequestsTab';
import EventLogTab from './EventLogTab';
import { useRefresh } from "../../../context/RefreshContext";
import { getStaffById } from '../../../axios/Visitor/VisitorApi';
import CopyIconV216pxSvg from '../../../assets/images/icons/CopyIconV216pxSvg';
import { useSearchParams } from "react-router-dom";

const VisitorRosterDetail = ({ data, onBack, usersData, id, refreshData, onRefresh }) => {
    const { t } = useTranslation();

    const {
        genaralSettingDateFormat,
        genaralSettingTimeFormat,
        dateTimeFormat,
        profile
    } = useAuth();

    const [openInfo, setOpenInfo] = useState(true);
    const [tabValue, setTabValue] = useState(0);

    const [refresh, setRefresh] = useState(false);
    const [approvers, setApprovers] = useState([]);
    const [searchParams] = useSearchParams();
    const eventVisitorId = searchParams.get("eventVisitorId");

    useEffect(() => {
        fetchApprovers();
    }, [id]);

    const fetchApprovers = async () => {
        const payload = {
            id: id,
            langId: localStorage.getItem("i18nextLngId"),
        };

        try {
            const responses = await getStaffById(payload);
            setApprovers(responses.data?.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    const handleRefresh = () => {
        setRefresh((prev) => !prev);
    };

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const a11yProps = (index) => {
        return {
            id: `user-tab-${index}`,
            'aria-controls': `user-tabpanel-${index}`,
        };
    };

    const formatTime = (time, formatStr) => {
        if (!time) return "-";

        try {
            const parsed = parse(time, "HH:mm:ss", new Date());
            return format(parsed, formatStr);
        } catch {
            return time;
        }
    };

    const formatDateTime = (isoString, formatStr) => {
        if (!isoString) return "-";

        try {
            const date = new Date(isoString);
            return format(date, formatStr);
        } catch {
            return "-";
        }
    };

    useEffect(() => {
        if (eventVisitorId) {
            setTabValue(1);
        }
    }, [eventVisitorId]);

    const handleCopyInviteUrl = async () => {
        const inviteUrl = `${window.location.origin}/portal/visitor-registration?visitorURL=${data.id}&comid=${profile?.companyId}`;


        try {
            await navigator.clipboard.writeText(inviteUrl);
        } catch (error) {
            console.error("Copy failed:", error);
        }
    };

    if (!data) return null;



    return (
        <>
            <div className='space-y-4'>
                {/* HEADER */}
                <div className="flex items-center gap-4 my-2">
                    <div
                        onClick={onBack}
                        className="cursor-pointer text-[#1F2937] hover:text-black"
                    >
                        <ArrowBackIosNewIcon fontSize="small" />
                    </div>

                    <h2 className="text-xl font-semibold truncate">
                        {data?.name}
                    </h2>
                </div>

                {/* INFORMATION */}
                <div className="bg-[#F9FAFB] p-4 rounded-[16px] w-full">
                    {/* HEADER */}
                    <div
                        className="flex items-center justify-between cursor-pointer"
                        onClick={() => setOpenInfo(prev => !prev)}
                    >
                        <h2 className="text-xl font-semibold">
                            {t("common.information")}
                        </h2>

                        {openInfo ? (
                            <KeyboardArrowUpIcon />
                        ) : (
                            <KeyboardArrowDownIcon />
                        )}
                    </div>

                    {/* CONTENT */}
                    <div
                        className={`
        transition-all duration-300 overflow-hidden
        ${openInfo ? "max-h-[1000px] mt-4" : "max-h-0"}
    `}
                    >
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-x-10 gap-y-3">

                            {/* LEFT COLUMN */}
                            <div className="space-y-3">

                                {/* DATE */}
                                <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                    <div className="text-[#9CA3AF] font-medium">
                                        {t("common.date")}
                                    </div>

                                    <div className="text-[#111827]">
                                        {formatDateTime(
                                            data.startDate,
                                            genaralSettingDateFormat
                                        )}{" "}
                                        -{" "}
                                        {formatDateTime(
                                            data.endDate,
                                            genaralSettingDateFormat
                                        )}
                                    </div>
                                </div>

                                {/* TIME */}
                                <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                    <div className="text-[#9CA3AF] font-medium">
                                        {t("common.content-036")}
                                    </div>

                                    <div className="text-[#111827]">
                                        {genaralSettingTimeFormat
                                            ? formatTime(
                                                data.startTime,
                                                genaralSettingTimeFormat
                                            )
                                            : data.startTime}

                                        {" - "}

                                        {genaralSettingTimeFormat
                                            ? formatTime(
                                                data.endTime,
                                                genaralSettingTimeFormat
                                            )
                                            : data.endTime}
                                    </div>
                                </div>

                                {/* REGISTRATION */}
                                <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                    <div className="text-[#9CA3AF] font-medium">
                                        {t("common.registrtion-period")}
                                    </div>

                                    <div className="text-[#111827]">
                                        {formatDateTime(
                                            data.registrationStart,
                                            dateTimeFormat
                                        )}{" "}
                                        -{" "}
                                        {formatDateTime(
                                            data.registrationEnd,
                                            dateTimeFormat
                                        )}
                                    </div>
                                </div>

                                {/* ASSIGNED */}
                                {!data.isPublic && (
                                    <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                        <div className="text-[#9CA3AF] font-medium">
                                            {t("common.assigned")}
                                        </div>

                                        <div className="flex flex-wrap gap-1">
                                            {approvers?.map((user, index) => (
                                                <span key={user.id}>
                                                    <span className="text-[#0057FF]">
                                                        {user.fullName}
                                                    </span>

                                                    {index < approvers.length - 1 && ","}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {data.isPublic && (
                                    <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                        <div className="text-[#9CA3AF] font-medium">
                                            {t("common.description")}
                                        </div>

                                        <div className="text-[#111827] break-words">
                                            {data.remark || "-"}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* RIGHT COLUMN */}
                            <div className="space-y-3">

                                {/* LIMIT */}
                                <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                    <div className="text-[#9CA3AF] font-medium">
                                        {t("common.limit")}
                                    </div>

                                    <div className="text-[#111827]">
                                        {data.maxParticipants} (
                                        {data.maxPerDay
                                            ? `${data.maxPerDay} ${t("common.max-per-day")}`
                                            : t("common.no-limit")}
                                        )
                                    </div>
                                </div>

                                {/* TYPE */}
                                <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                    <div className="text-[#9CA3AF] font-medium">
                                        {t("common.type")}
                                    </div>

                                    <div
                                        className="flex items-center gap-1"
                                        style={{
                                            color: data.isPublic
                                                ? "#0057FF"
                                                : "#F59E0B"
                                        }}
                                    >
                                        <span
                                            className="w-2 h-2 rounded-full"
                                            style={{
                                                backgroundColor: data.isPublic
                                                    ? "#0057FF"
                                                    : "#F59E0B"
                                            }}
                                        />

                                        {data.isPublic
                                            ? t("common.public")
                                            : t("common.private")}
                                    </div>
                                </div>

                                {/* ADDRESS */}
                                {data.address && (
                                    <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                        <div className="text-[#9CA3AF] font-medium">
                                            {t("common.address")}
                                        </div>

                                        <div className="text-[#111827] break-words">
                                            {data.address}
                                        </div>
                                    </div>
                                )}

                                {/* INVITE URL */}
                                <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                    <div className="text-[#9CA3AF] font-medium">
                                        {t("common.invite-url")}
                                    </div>

                                    <div className="flex items-center gap-2 min-w-0">
                                        <a
                                            href={`${window.location.origin}/portal/visitor-registration?visitorURL=${data.id}&comid=${profile?.companyId}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="
        text-blue-600 underline
        truncate
        block
        max-w-full
    "
                                            title={`${window.location.origin}/portal/visitor-registration?visitorURL=${data.id}&comid=${profile?.companyId}`}
                                        >
                                            {`${window.location.origin}/portal/visitor-registration?visitorURL=${data.id}&comid=${profile?.companyId}`}
                                        </a>

                                        <Tooltip
                                            title={t("common.copy-link")}
                                            placement="right"
                                            arrow
                                        >
                                            <button
                                                type="button"
                                                onClick={handleCopyInviteUrl}
                                                className="cursor-pointer hover:opacity-70 transition"
                                            >
                                                <CopyIconV216pxSvg />
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>

                                {/* DESCRIPTION */}
                                {!data.isPublic && (
                                    <div className="grid grid-cols-[160px_1fr] items-start gap-3">
                                        <div className="text-[#9CA3AF] font-medium">
                                            {t("common.description")}
                                        </div>

                                        <div className="text-[#111827] break-words">
                                            {data.remark || "-"}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* TABS */}
                <div>
                    <CustomTabsV2
                        variant="fullWidth"
                        indicatorColor='none'
                        value={tabValue}
                        onChange={handleChangeTab}
                    >
                        <Tab
                            label={t('common.visitors')}
                            {...a11yProps(0)}
                            disableRipple
                        />

                        <Tab
                            label={t('common.requests')}
                            {...a11yProps(1)}
                            disableRipple
                        />

                        <Tab
                            label={t('drawer.event-log')}
                            {...a11yProps(2)}
                            disableRipple
                        />
                    </CustomTabsV2>

                    <CustomTabPanel value={tabValue} index={0}>
                        <VisitorsTab
                            refreshData={refreshData}
                            onRefresh={onRefresh}
                            refresh={refresh}
                            dataInfo={data}
                        />
                    </CustomTabPanel>

                    <CustomTabPanel value={tabValue} index={1}>
                        <RequestsTab
                            refreshData={refreshData}
                            onRefresh={onRefresh}
                            refresh={refresh}
                            dataInfo={data}
                            eventVisitorId={eventVisitorId}
                        />
                    </CustomTabPanel>

                    <CustomTabPanel value={tabValue} index={2}>
                        <EventLogTab
                            refreshData={refreshData}
                            onRefresh={onRefresh}
                            refresh={refresh}
                            dataInfo={data}
                        />
                    </CustomTabPanel>
                </div>
            </div>
        </>
    );
};

export default VisitorRosterDetail;